export default __webpack_public_path__ + "static/SR USA - Non-GMO Project Verified Caramel Colors - Certificate-f18788fdd407ff6947ca182bb82912ed.pdf";